import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

import { AuthenticationService } from '../services/auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private authService: AuthenticationService,
    private router: Router,
    private dialog: MatDialog
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const user = this.authService.getCurrentUser();

    if (user && user.token && req.url.startsWith(environment.baseAPIUrl)) {
      const cloned = req.clone({
        headers: req.headers.set('Authorization', 'Bearer ' + user.token),
      });

      return next.handle(cloned).pipe(
        tap({
          next: () => {},
          error: (err: any) => {
            if (err instanceof HttpErrorResponse) {
              if (err.status === 401) {
                this.dialog.closeAll();
                void this.router.navigate(['/auth/login']);
              }
            }
          },
        })
      );
    } else {
      return next.handle(req);
    }
  }
}
